module.exports = __webpack_public_path__ + "img/11.cda5a440.png";